import React, { useState } from "react";
import Header from "./components/Header/header";
import HomePage from "./pages/Home";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
import Loader from "./components/loader";

function App() {
  const [loadPage, setLoadPage] = useState(true);
  setTimeout(() => {
    setLoadPage(false);
  }, 5000);
  return (
    <>
      {loadPage && <Loader />}
      {!loadPage && (
        <div className="App">
          <Header />
          <div className="">
            <HomePage />
            <About />
            <Projects />
            <Contact />
          </div>
        </div>
      )}
    </>
  );
}

export default App;
